export default __webpack_public_path__ + "static/media/employeetrackerpic.309bd323.png";